import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from "../../Common/Lib/react-tabs/esm/index";
import {BrowserRouter as Router, Link} from "react-router-dom";
import { PackageConstruction, PackageInterior } from "../../data";
import "./PackageTab.css";


function App(){
    return(
      <>
        <Tabs className="ptab">
        <TabList>
          <Tab>
          <div className="lpd-construction lpd-overpass-extra-bold-shark-14px">CONSTRUCTION</div>
          </Tab>
          <Tab>
          <div className="lpd-place-1 lpd-typographybodycaption-14-semi-bold">INTERIOR</div>
          </Tab>
        </TabList>
        <TabPanel >
          <div className="lpd-flex-row">
              <row className="wrap">
            { 
              PackageConstruction.map(item => 
                <column className="f-column-3">
                <div className={`${item.className}`}>
                  <div className="lpd-text-24 lpd-valign-text-middle lpd-typographyheadlineh4-extrabold-24">{item.option}</div>
                  <div className="lpd-icons" style={{ backgroundImage: `url(${item.icon})` }}></div>
                  <div className="lpd-group-69">
                    <div className="lpd-number lpd-valign-text-middle lpd-typographyheadlineh2-extrabold-40">{item.amount}</div>
                    <div className="lpd-text-2-1 lpd-valign-text-middle lpd-typographybody16-regular">{item.area}</div>
                  </div>                 
                  <div className="lpd-i26012314-66600 lpd-component lpd-component-wrapper not-ready">
                  <Router forceRefresh={true}>
                    <Link to={`/packagedetails/${item.categoryId}/${item.id}`}>
                      <div className="lpd-master-button-4KxvdI">
                        <div className="lpd-button-i2601231466-hdozzc lpd-valign-text-middle">{item.button}</div>
                      </div>
                    </Link>  
                  </Router>                
                  </div>
                </div>
                </column>
              )
            }
            </row>
          </div>
        </TabPanel>
        <TabPanel>
          <div className="lpd-flex-row">
          <row className="wrap">
          { 
              PackageInterior.map(item => 
                <column className="f-column-3">
                <div className={`${item.className}`}>
                  <div className="lpd-text-24 lpd-valign-text-middle lpd-typographyheadlineh4-extrabold-24">{item.option}</div>
                  <div className="lpd-icons" style={{ backgroundImage: `url(${item.icon})` }}></div>
                  <div className="lpd-group-69">
                    <div className="lpd-number lpd-valign-text-middle lpd-typographyheadlineh2-extrabold-40">{item.amount}</div>
                    <div className="lpd-text-2-1 lpd-valign-text-middle lpd-typographybody16-regular">{item.area}</div>
                  </div>                 
                  <div className="lpd-i26012314-66600 lpd-component lpd-component-wrapper not-ready">
                  <Router forceRefresh={true}>
                    <Link to={`/packagedetails/${item.categoryId}/${item.id}`}>
                      <div className="lpd-master-button-4KxvdI">
                        <div className="lpd-button-i2601231466-hdozzc lpd-valign-text-middle">{item.button}</div>
                      </div>
                    </Link> 
                  </Router>                                 
                  </div>
                </div>
                </column>
              )
            }
            </row>
          </div>
        </TabPanel>
      </Tabs>   
      <hr id ="estimate" style={{color:"transparent"}}/>
      </>
    );
}

export default App